import { useState } from "react";
import { observer } from "mobx-react";
import {
  VersionButton,
  NewVersionButton,
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useVersioning, ScrollButtonContainer
} from "@tools";
import { useResizeObserver } from "@hooks";
import { Grid } from "@material-ui/core";

export const Versioning = observer(() => {
  const { hasEditorPrivileges, isProposal } = useEstimateEditorSettings();
  const { visibilityMode, currentVersion } = useEstimateEditorStore();
  
  const [isOverflowing, setOverflowing] = useState(false);
  const [scrollReachedStart, setReachedStart] = useState(false);
  const [scrollReachedEnd, setReachedEnd] = useState(false);
  
  const { versions, editable, clickable } = useVersioning();
  
  const handleResize = (element) => {
    const o = element.offsetWidth < element.scrollWidth;
    if (o !== isOverflowing) setOverflowing(o);
  };
  
  const containerRef = useResizeObserver(handleResize);
  
  const handleScroll = () => {
    if(!containerRef.current) return;
    const s = containerRef.current.scrollLeft;
    const w = containerRef.current.scrollWidth - containerRef.current.offsetWidth;
    if(s <= 0 || scrollReachedStart)
      setReachedStart(s <= 0)
    if(s >= w || scrollReachedEnd)
      setReachedEnd(s >= w)
  }
  
  if(!hasEditorPrivileges && !versions.length)
    return null;
  
  return (
    <Grid
      item container
      alignItems="center"
      wrap="nowrap"
      className="overflow-hidden -my-1 py-1"
    >
      <Grid
        item container
        ref={containerRef}
        alignItems="center"
        wrap="nowrap"
        className="overflow-hidden -my-1 py-1 w-max"
        onScroll={handleScroll}
      >
        {
          versions.map(({ key, name, locked, visible }) => (
            <VersionButton
              key={key}
              identifier={key}
              name={name}
              selected={key === currentVersion}
              clickable={clickable}
              used={!!visible}
              locked={!!locked && !isProposal}
              editVisibility={visibilityMode}
              rememberScroll
              editable={editable}
              blockActionMenu
            />
          ))
        }
      </Grid>
      {
        editable &&
        <NewVersionButton rememberScroll />
      }
      {
        isOverflowing &&
        <ScrollButtonContainer
          containerRef={containerRef}
          scrollReachedStart={scrollReachedStart}
          scrollReachedEnd={scrollReachedEnd}
          inTable={false}
        />
      }
    </Grid>
  )
})